<template>
  <div>
    <v-dialog persistent v-model="this.showDialog" max-width="700">
      <v-card class="pa-5">
        <v-card-text class="text-subtitle-1 font-weight-bold">
          {{ this.questionText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn @click="$emit('onCancel')" color="gray" text>{{ this.negativeText }}</v-btn>
          <v-btn @click="$emit('onConfirm')" :color="confirmColor" outlined> {{ this.positiveText }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: ['showDialog', 'confirmColor', 'questionText', 'positiveText', 'negativeText']
}
</script>



// WEBPACK FOOTER //
// src/components/common/ConfirmDialog.vue